import NotFoundPage from '@/pages/404.vue'
import AboutPage from '@/pages/about.vue'
import HomePage from '@/pages/index.vue'
import ParkingReservationPage from '@/pages/parking/reservations.vue'
import ParkingVehiclesPage from '@/pages/parking/vehicles.vue'
import ProfilePage from '@/pages/profile.vue'

const routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/parking/reservations/',
    component: ParkingReservationPage,
  },
  {
    path: '/parking/vehicles/',
    component: ParkingVehiclesPage,
  },
  {
    path: '/profile/',
    component: ProfilePage,
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
]

export default routes
